import Sliders from "../../components/Sliders";
function SlidersPage() {
  return (
    <div>
      <Sliders />
    </div>
  );
}

export default SlidersPage;
